import React, { useEffect } from "react";

const HomeCarousel = () => {
  useEffect(() => {
    // Logic to update the background images and button visibility based on screen size
    const updateImageAndButton = () => {
      const slideOne = document.querySelector(".slide-one");
      const slideTwo = document.querySelector(".slide-two");
      const buttons = document.querySelectorAll(".btn_get_started");

      if (window.innerWidth <= 780) {
        slideOne.style.backgroundImage =
          "url('../assets/images/home_mobile_banner_1.jpg')";
        slideTwo.style.backgroundImage =
          "url('../assets/images/home_mobile_banner_2.jpg')";

        buttons.forEach((btn) => (btn.style.display = "none")); // Hide button for mobile
      } else {
        slideOne.style.backgroundImage =
          "url('../assets/images/home_desktop_banner_1.jpg')";
        slideTwo.style.backgroundImage =
          "url('../assets/images/home_desktop_banner_2.jpg')";

        buttons.forEach((btn) => (btn.style.display = "block")); // Show button for larger screens
      }
    };

    // Add event listener for window resize
    window.addEventListener("resize", updateImageAndButton);

    // Initial check
    updateImageAndButton();

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("resize", updateImageAndButton);
    };
  }, []);

  return (
    <div
      id="homeCarousel"
      className="carousel slide"
      data-bs-ride="carousel"
      data-bs-interval="4000"
    >
      <div className="carousel-inner">
        {/* Slide 1 */}
        <div className="carousel-item active">
          <div
            className="background_home_section d-flex justify-content-start  align-items-center bg-size blur-up lazyloaded slide-one"
          >
            <div className="container-fluid-lg  ">
              <button
                onClick={() => (window.location.href = "/shop")}
                className="btn_get_started maring-minus-button-shopnow btns btn-animation-blue margin-top-button home-button mend-auto"
              >
                Shop Now <i className="fa-solid fa-right-long icon"></i>
              </button>
            </div>
          </div>
        </div>

        {/* Slide 2 */}
        <div className="carousel-item">
          <div
            className="background_home_section d-flex justify-content-start align-items-center slide-two"
          >
            <div className="container-fluid-lg">
              <button
                onClick={() => (window.location.href = "/shop")}
                className="btn_get_started btns btn-animation-blue margin-top-button home-button mend-auto"
              >
                Shop Now <i className="fa-solid fa-right-long icon"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Carousel Controls */}
      <button
        className="carousel-control-prev"
        type="button"
        data-bs-target="#homeCarousel"
        data-bs-slide="prev"
      >
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Previous</span>
      </button>
      <button
        className="carousel-control-next"
        type="button"
        data-bs-target="#homeCarousel"
        data-bs-slide="next"
      >
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Next</span>
      </button>
    </div>
  );
};

export default HomeCarousel;
